import { IAccessPermission } from "../models/AccessPermission";

export function hasPermission(permissions: IAccessPermission[], permission: IAccessPermission) {
    return permissions.find(o => o.functionalityType === permission.functionalityType && (o.access & permission.access) > 0) !== undefined;
}